import React from 'react';
import { Box, AppBar, Toolbar } from '@mui/material';
import svgSrc from 'assets/images/logo.svg';
import { useIsMobile } from '../../../shared/hooks';

interface LayoutProps {
  children: React.ReactNode;
  showHeader?: boolean;
}

export const Layout = (props: LayoutProps) => {
  const { children, showHeader = true } = props;
  const isMobile = useIsMobile();
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100dvh' }}>
      {showHeader && (
        <AppBar
          component="nav"
          sx={{
            backgroundColor: '#262B2D',
            position: 'relative',
            boxShadow: 'none',
            height: '56px',
          }}
        >
          <Toolbar
            sx={{
              paddingLeft: '16px !important',
              paddingRight: '16px !important',
              minHeight: '56px !important',
            }}
          >
            <Box
              component={'img'}
              sx={{
                width: '110px',
              }}
              alt="NewtonX_logo"
              src={svgSrc}
            ></Box>
          </Toolbar>
        </AppBar>
      )}
      <Box
        sx={{
          flex: '1 1 auto',
          display: 'flex',
          justifyContent: 'center',
          paddingTop: isMobile ? '32px' : '64px',
          paddingLeft: '16px',
          paddingRight: '16px',
          background: 'rgba(249, 250, 251, 1)',
          paddingBottom: isMobile ? '32px' : '64px',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default Layout;
